export default __webpack_public_path__ + "c91e57f091694b2a6d0e3a918479b25c.jpeg";